import React from 'react'
import { Tooltip } from 'hljd'
import { observer } from 'mobx-react'
import style from './style.module.less'
import DocumentList from '../Editor/DocumentList'

export default observer(
  ({
    store: {
      id,
      name,
      status: { text, color, icon, type },
      desc,
      certificationInfo,
      certificationBrand,
      deleteCertification,
      previewCertification,
      getViewName
    }
  }) => (
    <div className={style.container}>
      <div className={style.topBar}>
        <Tooltip placement="top" title={name}>
          <span className={style.name}>{getViewName(name)}</span>
        </Tooltip>
        <span className={style.status} style={{ color }}>
          <img src={icon} />
          {text}
        </span>
        <span className={style.extra}>
          <span onClick={() => deleteCertification(id)}>删除</span>
          {type != 1 && <span onClick={previewCertification}>修改信息</span>}
        </span>
      </div>
      <div className={style.infoList}>
        <div className={style.listGroup}>
          <div className={style.label}>认证说明：</div>
          <div className={style.info}>{desc}</div>
        </div>
        <div className={style.listGroup}>
          <div className={style.label}>证明材料：</div>
          <div className={style.info}>
            <DocumentList list={certificationInfo} viewer={true} />
          </div>
        </div>
        {!!certificationBrand.length && (
          <div className={style.listGroup}>
            <div className={style.label}>品牌资料：</div>
            <div className={style.info}>
              <DocumentList list={certificationBrand} viewer={true} />
            </div>
          </div>
        )}
      </div>
    </div>
  )
)
